document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.print-content').forEach(element => {
        element.addEventListener('click', () => {
            document.body.classList.add('is-printing');
            window.print()
        })
    })

});